// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo } from "react";
import { LuX } from "react-icons/lu";
import { useSelector, useDispatch } from "react-redux";
import { loginFailure } from "../../store/auth/action";
import { clearStorage } from "../../utils/clearstore";

export const SESSION_EXPIRED_ERROR =
  "Your session has expired. Please log in again to continue.";

function AuthError() {
  const dispatch = useDispatch();

  const { error } = useSelector((state) => ({ error: state.error }));
  const isSessionExpired = error === SESSION_EXPIRED_ERROR;

  const onClose = () => {
    dispatch(loginFailure(""));
    clearStorage();
    window.location.reload();
  };

  return (
    <div className="fixed inset-0 z-[100] select-none flex items-center justify-center bg-black/50 p-4">
      <div className="font-geist relative w-full max-w-[448px] bg-general-background rounded-lg border border-general-border shadow-lg flex flex-col text-left overflow-hidden">
        <div className="flex items-center px-4 pt-4 pb-3 shrink-0">
          <span className="flex-1 text-general-foreground text-xl font-semibold leading-6">
            {isSessionExpired ? "Session expired" : "Error!"}
          </span>
        </div>
        <div className="px-4 pb-4">
          <p className="text-unofficial-ghost-foreground text-sm font-normal leading-5">
            {error}
          </p>
        </div>
        <div className="flex justify-end px-4 pb-4 shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="flex items-center justify-center min-h-9 px-4 py-2 rounded-lg bg-general-primary text-general-primary-foreground text-sm font-medium hover:opacity-90 ani"
          >
            Okay
          </button>
        </div>
        {!isSessionExpired && (
          <button
            type="button"
            onClick={onClose}
            className="absolute top-4 right-4 opacity-70 hover:opacity-100 ani"
          >
            <LuX className="size-4 text-general-foreground" />
          </button>
        )}
      </div>
    </div>
  );
}

export default memo(AuthError);
